<template>
  <div id="main-layout" class="h-screen">
    <Child />
  </div>
</template>

<script>
export default {
  name: "DefaultLayout"
};
</script>
